/* eslint-disable import/prefer-default-export */
import { useAppSelector } from '../app/hooks'

export const useEmojiState = () => {
  const emojiState = useAppSelector(({ emoji }) => emoji)
  return emojiState
}

// get emoji data
export const useEmojiNameToDisplayMap = (): Record<string, string> => {
  const emojiData = useAppSelector(({ emoji }) => emoji.nameToDisplayMap)
  return emojiData
}
